/**
 * Derives agency access from the server-enforced data visibility invariant rather than role names.
 */
import type { PermissionAssignmentDto } from 'src/store/generated/leela-api-generated';

export function isExternalUser (
  assignments: readonly PermissionAssignmentDto[],
): boolean {
  return assignments.some(
    assignment => assignment.dataVisibilityPolicy === 'AGENCY_RESTRICTED',
  );
}
